export default function SectionHeader({ eyebrow, title, action, testId }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6" data-testid={testId ? `${testId}-header` : undefined}>
      <div>
        {eyebrow && (
          <div className="mono text-[10px] uppercase tracking-[0.25em] text-[#00F0FF] mb-2">
            {eyebrow}
          </div>
        )}
        <h2 className="font-heading font-black text-3xl sm:text-4xl tracking-tight uppercase">
          {title}
        </h2>
      </div>
      {action}
    </div>
  );
}
